$(document).ready(function () {

    console.log("document ready recipes.js");

    let manageFacetedNavigation = {
        setup : function() {
            this.$select = $('.faceted-navigation__filters select');
            this.$tagActive = $('.faceted-results #tagActive');
        },

        removeTagFromUrl: function  (el) {
            let url = window.location.href.split('?')[0];
            $(el).attr("href", url);
        },

        removeSpaceFromText: function  (text) {
            return text.replace(/\s+/g, '');
        },

        changePage: function  (selectedOption) {
            let selectedOptionSanitized = this.removeSpaceFromText (selectedOption);
            window.location.replace(selectedOptionSanitized);
        },

        bindEvents:  function ()  {
            //ci mettiamo in ascolto dell'evento select2 perchè il tradizionale evento change
            //viene registrato 2 volte sulle select stilate con select2
            this.$select.on('select2:select', function(e){
                this.changePage(e.target.value);
            }.bind(this));

            this.removeTagFromUrl(this.$tagActive);
        },

        init: function () {
            try {
                this.setup();
                this.bindEvents();

            }
            catch (e) {
                console.error(e);
            }
        }
    };

    manageFacetedNavigation.init();
});

